import React from 'react'
import { XCircleIcon } from '@heroicons/react/24/outline'
import { FilledButton } from '../buttons/FilledButton'
export const DialogError: React.FC<{ message?: string; onRetry: () => void; retryTitle: string }> = ({ message, onRetry, retryTitle }) => {
  return (
    <>
      <div className="flex flex-row justify-center items-center">
        <XCircleIcon width={20} height={20} className="text-red-500" />
        <p className="text-gray-700 ml-2">{message}</p>
      </div>
      <div className="mt-6">
        <FilledButton label={retryTitle} onClick={onRetry} />
      </div>
    </>
  )
}
